import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import React, { useState } from 'react';
import { useAuth } from '../Authentication';
import LoadingPage from '../Loading/Page';
import Page from '../Page';
import EditProfileDialog from './edit/Dialog';
import ProfileDisplay from './ProfileDisplay';
import useEngineerWithSkills from './useEngineerWithSkills';

export default function Profile() {
  const [showEditDialog, setShowEditDialog] = useState(false);
  const { engineer, fetching: fetchingEngineer, reload: reloadEngineer } = useEngineerWithSkills();
  const { user } = useAuth();
  if (fetchingEngineer || !engineer || !user) return <LoadingPage />;
  async function handleCloseEdit(changed?: boolean) {
    if (changed) await reloadEngineer();
    setShowEditDialog(false);
  }
  return (
    <Page
      title="Profile"
      action={(
        <Button variant="text" color="primary" onClick={() => setShowEditDialog(true)}>
          Update Profile
        </Button>
      )}
    >
      <Box>
        <ProfileDisplay engineer={engineer} user={user} />
      </Box>
      <EditProfileDialog open={showEditDialog} onClose={handleCloseEdit} />
    </Page>
  );
}
